import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { Constants } from "../interfaces/constants";
import { UserViewComponent } from "./components/user/user-view.component";
import { MsalGuard } from "@azure/msal-angular";

const routes: Routes = [
  {
    path: Constants.routePaths.substitutes,
    children: [{ path: "", pathMatch: "full", component: UserViewComponent }],
    canActivate: [MsalGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SubstitutesRoutingModule { }
